import { useQuery } from '@tanstack/react-query';
import { garmentService } from '../Services';

export const NAV_CATEGORY_IDS = ['men', 'women'] as const;
export type NavCategoryId = (typeof NAV_CATEGORY_IDS)[number];

export const NAV_CATEGORY_TITLES: Record<NavCategoryId, string> = {
    men: 'Men',
    women: 'Women',
};

type CategoryLike = { id: string; garment_count: number };

export const isNavCategoryWithGarments = <T extends CategoryLike>(
    category: T,
): category is T & { id: NavCategoryId } =>
    (NAV_CATEGORY_IDS as readonly string[]).includes(category.id) && category.garment_count > 0;

export const useGetCategories = () => {
    return useQuery({
        queryKey: ['categories'],
        queryFn: () => garmentService.fetchCategories(),
    });
};
